import ApiService from "./ApiService";

const SubscriptionService = {
  async getSubscriptionInfo() {
    // GET /users/subscription
    const res = await ApiService.get("users/subscription");
    return res.data;
  },

  async getPlans() {
    // GET /subscriptions/plans
    // Імітуємо поведінку мобільної версії - просто викликаємо API і повертаємо результат
    try {
      const res = await ApiService.get("subscriptions/plans");
      
      // Axios повертає response об'єкт, res.data - це дані з API
      // Якщо запит успішний, повертаємо у форматі як в мобільній версії
      return {
        success: true,
        data: res.data,  // Повертаємо дані як є, як в мобільній версії
      };
    } catch (error) {
      console.error("Error fetching plans:", error);
      return {
        success: false,
        error: error.response?.data?.detail || error.response?.data?.message || error.message || "Failed to fetch plans",
        data: null,
      };
    }
  },

  async getPaymentLink(planId) {
    // POST /subscriptions/get-payment-link
    try {
      let requestBody = {};

      if (planId !== undefined && planId !== null) {
        const numericPlanId = Number(planId);
        if (!Number.isFinite(numericPlanId) || numericPlanId <= 0) {
          throw new Error("Invalid plan ID");
        }
        requestBody.plan_id = numericPlanId;
      }

      const res = await ApiService.post("subscriptions/get-payment-link", requestBody);
      
      return { 
        success: true, 
        data: res.data 
      };
    } catch (error) {
      console.error("Error getting payment link:", error);
      return {
        success: false,
        error: error.response?.data?.detail || error.response?.data?.message || error.message || "Failed to get payment link",
        data: null,
      };
    }
  },

  async getCancelOptions() {
    // GET /subscriptions/cancel/options
    try {
      const res = await ApiService.get("subscriptions/cancel/options");
      
      return { 
        success: true, 
        data: res.data 
      };
    } catch (error) {
      console.error("Error fetching cancel options:", error);
      return {
        success: false,
        error: error.response?.data?.detail || error.response?.data?.message || error.message || "Failed to fetch cancel options",
        data: null,
      };
    }
  },

  async cancelSubscription(reasonCode, customReason) {
    // POST /subscriptions/cancel
    try {
      const requestBody = {
        ...(reasonCode ? { reason_code: reasonCode } : {}),
        ...(customReason ? { custom_reason: customReason } : {}),
      };

      const res = await ApiService.post("subscriptions/cancel", requestBody);
      
      return { 
        success: true, 
        data: res.data 
      };
    } catch (error) {
      console.error("Error canceling subscription:", error);
      return {
        success: false,
        error: error.response?.data?.detail || error.response?.data?.message || error.message || "Failed to cancel subscription",
        data: null,
      };
    }
  },
};

export default SubscriptionService;
